import view from './view.js';

export { view};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/error_duty/index.js